import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { JSX } from '@redneckz/uni-jsx';
import { Icon } from '../Icon/Icon.js';
import { defaultStyle } from './defaultStyle.js';
const styles = {
    ...defaultStyle,
    border: 'border-b border-b-2 border-gray last:border-0',
    position: 'relative flex items-center justify-center',
};
// TODO: Добавить метод определения центральной точки
export const ZoomButton = JSX(({ yandexMaps, direction = 'in' }) => {
    const iconName = direction === 'in' ? 'PlusIcon' : 'MinusIcon';
    const changeZoom = () => {
        const currentZoom = yandexMaps.current.getZoom();
        const newZoom = direction === 'in' ? currentZoom + 1 : currentZoom - 1;
        yandexMaps.current.setZoom(newZoom, { checkZoomRange: true });
    };
    return (_jsx("div", { onClick: changeZoom, className: `${Object.values(styles).join(' ')} bg-white select-none cursor-pointer w-12 h-12`, children: _jsx(Icon, { name: iconName, width: "20", height: "16" }) }));
});
//# sourceMappingURL=ZoomButton.js.map